// @ts-nocheck
export function formatCurrency(amount: number): string {
  return `฿${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(isoDate: string): string {
  if (!isoDate) return '-';
  const [y, m, d] = isoDate.split('-');
  return `${d}/${m}/${y}`;
}

export function formatDateTime(isoDateTime: string): string {
  if (!isoDateTime) return '-';
  const date = new Date(isoDateTime);
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${d}/${m}/${y} ${h}:${min}`;
}

export function statusColor(status: string): string {
  switch (status) {
    case 'missing': return 'bg-red-100 text-red-700 border-red-200';
    case 'requested': return 'bg-amber-100 text-amber-700 border-amber-200';
    case 'received': return 'bg-blue-100 text-blue-700 border-blue-200';
    case 'verified': return 'bg-green-100 text-green-700 border-green-200';
    case 'has_reference': return 'bg-cyan-100 text-cyan-700 border-cyan-200';
    case 'waived': return 'bg-gray-100 text-gray-500 border-gray-200';
    default: return 'bg-gray-100 text-gray-600 border-gray-200';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'missing': return 'Missing';
    case 'requested': return 'Requested';
    case 'received': return 'Received';
    case 'verified': return 'Verified';
    case 'has_reference': return 'Has Reference';
    case 'waived': return 'Waived';
    default: return status;
  }
}

export function daysSince(dateStr: string | null): number | null {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  const now = new Date();
  return Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
}

export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
